if (!("loading" in HTMLImageElement.prototype)) {
  (() => {
    if (window.MutationObserver) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.srcset = img.dataset.srcset;
            observer.unobserve(img);
          }
        });
      });
      document
        .querySelectorAll("img[loading=lazy]")
        .forEach(function (lazyImage) {
          observer.observe(lazyImage);
        });
    }
  })();
}

function polyfilledElement(element) {
  return new Proxy(element, {
    get(target, prop) {
      if (prop === "querySelector") {
        return function (selector) {
          const parentSelector = /(.*):has\(>(.*)\)/gm;
          const hasParentSelector = parentSelector.exec(selector);
          if (
            Array.isArray(hasParentSelector) &&
            hasParentSelector.length > 1
          ) {
            return document
              .querySelector(hasParentSelector[2])
              .closest(hasParentSelector[1]);
          }
          return document.querySelector(selector);
        };
      }
      if (typeof target[prop] === "function") {
        return function () {
          return target[prop].apply(target, arguments);
        };
      }
      return target[prop];
    },
  });
}
